import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import { FiMapPin, FiPhone } from 'react-icons/fi';
import { SITE_CONFIG } from '../data/content';

const Footer = () => {
  const allSuburbs = [...SITE_CONFIG.prioritySuburbs, ...SITE_CONFIG.nearbySuburbs];

  return (
    <footer className="bg-[#0a1e1e] text-teal-50/80 pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          <div className="space-y-6">
            <Link to="/" className="block group">
              <div className="bg-white p-4 rounded-2xl inline-block mb-4 transition-transform group-hover:scale-105">
                <img src={SITE_CONFIG.logo} alt={SITE_CONFIG.chiropracticBrand} className="h-12 w-auto" />
              </div>
              <span className="text-white font-black text-xl block leading-tight">
                Canberra City<br />Chiropractic
              </span>
            </Link>
            <p className="text-sm leading-relaxed text-teal-100/60">
              {SITE_CONFIG.tagline}. Providing personalised care for back pain, neck pain, and musculoskeletal health in Canberra.
            </p>
          </div>

          <div>
            <h3 className="text-white font-black text-lg mb-6 border-b border-teal-800 pb-2 inline-block">Conveniently located in Deakin</h3>
            <p className="text-xs mb-4 text-teal-100/60">We welcome patients from Deakin and throughout Canberra, including:</p>
            <div className="flex flex-wrap gap-x-2 gap-y-1 text-[10px] uppercase tracking-wider opacity-60">
              {allSuburbs.map((suburb, index) => (
                <span key={index} className="hover:text-teal-300 transition-colors cursor-default">
                  {suburb}{index !== allSuburbs.length - 1 ? ' •' : ''}
                </span>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-white font-black text-lg mb-6 border-b border-teal-800 pb-2 inline-block">Services</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/back-pain" className="hover:text-teal-300 transition-colors">Back Pain</Link></li>
              <li><Link to="/neck-pain" className="hover:text-teal-300 transition-colors">Neck Pain</Link></li>
              <li><Link to="/headaches-migraines" className="hover:text-teal-300 transition-colors">Headaches & Migraine</Link></li>
              <li><Link to="/myofascial-dry-needling" className="hover:text-teal-300 transition-colors">Dry Needling</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-black text-lg mb-6 border-b border-teal-800 pb-2 inline-block">Contact</h3>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3">
                <SafeIcon icon={FiMapPin} className="text-teal-400 mt-1 flex-shrink-0" />
                <span>{SITE_CONFIG.address}</span>
              </li>
              <li className="flex items-center gap-3">
                <SafeIcon icon={FiPhone} className="text-teal-400 flex-shrink-0" />
                <span className="font-bold text-white">{SITE_CONFIG.phone}</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-teal-900 pt-10 text-center text-xs text-teal-100/40">
          <p>&copy; {new Date().getFullYear()} {SITE_CONFIG.chiropracticBrand}. AHPRA Registered Practitioners.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;